import { gql } from "@apollo/client";

export const programQuery = gql`
  query programs($scenarioId: ID!, $filter: ProgramFilterInput) {
    data(scenarioId: $scenarioId) {
      programs(filter: $filter) {
        items {
          id
          code
          name
        }
        pageInfo {
          hasPreviousPage
          hasNextPage
          page
          size
          total
        }
      }
    }
  }
`;
